
import Button from '../../../components/base/Button';

export default function ProductsCTA() {
  const handleContactClick = () => {
    window.open('tel:+21620403150', '_self');
  };

  return (
    <section className="py-20 bg-red-600">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Besoin d'Aide pour <span className="text-red-200">Choisir</span> ?
          </h2>
          <p className="text-xl text-red-100 mb-8 leading-relaxed">
            Nos experts vous conseillent gratuitement pour sélectionner les équipements 
            les mieux adaptés à vos besoins et votre budget.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button 
              variant="outline" 
              size="lg" 
              className="border-white text-white hover:bg-white hover:text-red-600"
              onClick={handleContactClick}
            >
              <i className="ri-phone-line mr-2"></i>
              Contactez-nous
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Livraison Gratuite</h3>
              <p className="text-red-100">Dès 200€ d'achat</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Installation Incluse</h3>
              <p className="text-red-100">Par nos techniciens</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Garantie 3 ans</h3>
              <p className="text-red-100">Sur tous nos produits</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
